import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";
import SectionTitle from "../atoms/SectionTitle";
import SectionTextBox from "../atoms/SectionTextBox";
import SimbolTarget from "../atoms/SimbolTarget";

// Title 기준 왼쪽
const Section = styled.section`
    display: flex;
    width: 100%;
    margin-bottom: 140px;
    justify-content: space-between;
    align-items: center;
    ${device.tablet} {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 80px;
    }
    ${device.mobile} {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 50px;
    }
`;
const LeftBox = styled.div`
    width: 40%;
    ${device.tablet} {
        width: 100%;
    }
    ${device.mobile} {
        width: 100%;
    }
`;
const RightBox = styled.div`
    display: flex;
    justify-content: right;
    position: relative;
    width: 60%;
    
    div:first-child {
        position: absolute;
         left: ${(props) => props.left ? props.left : "110px"};
        top: ${(props) => props.top ? props.top : "67px"};
        z-index: 1;
        
        img {
            width: 100%;
            max-width: 441px;
            height: auto;
            z-index: 2;
            display: block;
        }
    }
    div:last-child {
        position: relative;
        z-index: 0;
        &:hover {
            z-index: 2;
        }
        img {
            width: 100%;
            max-width: 435px;
            height: 650px;
            object-fit: cover;
            display: block;
        }
    }
    ${device.tablet}{
        width: 100%;
        div:first-child {
            position: absolute;
            left: 0;
            width: 55%;
            &:hover {
                z-index: 10;
            }
        }
        div:last-child {
        position: relative;
            width: 50%;
            left: -40px;
            img {
                height: auto;
            }
        }
    }
    ${device.mobile}{
        justify-content: ${(props) => (props.img1 === "" ? "left" : "right")};
        padding-left: ${(props) => (props.img1 === "" ? "10px" : "0")};
        width: 100%;
        div:first-child {
            position: absolute;
            left: 0;
            width: 55%;
            &:hover {
                z-index: 10;
            }
        }
        div:last-child {
            position: relative;
            width: 50%;
            left: -10px;
            img {
                height: auto;
            }
        }
    }
`;
const ImgBox = styled.div``;
const Img = styled.img``;


const LeftSection = ({
                         title,
                         enTitle,
                         subTitle,
                         textList,
                         list,
                         img1,
                         top,
                         left,
                         img2,
                         simbol,
                         simbolId,
                         content
                     }) => {
    return (
        <>
            <Section>
                <LeftBox>
                    {title && <SectionTitle
                        title={title}
                        enTitle={enTitle}
                        subTitle={subTitle}/>}
                    <SectionTextBox
                        textList={textList}
                        list={list}
                        content={content}
                    />
                </LeftBox>

                <RightBox img1={img1} top={top} left={left}>
                    <ImgBox> <Img src={img1}/></ImgBox>
                    <ImgBox> <Img src={img2}/></ImgBox>
                </RightBox>
            </Section>

            {simbol && <SimbolTarget id={simbolId}/>}

        </>
    );
};

export default LeftSection;
